import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { currentBudgetSelector } from "../currentBudgetSelector";

export const currentBudgetAmountSelector = createDraftSafeSelector(
  [currentBudgetSelector],
  (budget) => {
    return budget?.body?.amount ?? 0;
  },
);
